export const Config = {
    IsProd: process.env.REACT_APP_IsProd === "true",
    APIBaseUrl: process.env.REACT_APP_APIBaseUrl as string,
    DIYWebsiteBuilderAPIKey: process.env.REACT_APP_DIY_WEBSITE_BUILDER_API_Key as string,
}